<script lang="ts">
	import IconButton from '../../../basic/buttons/IconButton.svelte';
	import DefaultSimpleList from '../../../basic/list/DefaultSimpleList.svelte';
	import Searchbar from '../../../basic/search/Searchbar.svelte';
	import { editFolderStore, type FolderListStore } from '../../../stores/FolderStore.svelte';
	import type { Folder } from '../../../types/FolderTypes';
	import type { Client } from '../../../types/GeneralTypes';
	import { onDestroy, onMount } from 'svelte';
	import { _ } from 'svelte-i18n';
	import FolderCreateModal from './FolderCreateModal.svelte';
	import FolderEditModal from './FolderEditModal.svelte';
	import ListItemFolder from './ListItemFolder.svelte';

	interface Props {
		client: Client;
		folderListStore: FolderListStore;
		onSelectionChanged: (item: Folder) => void;
	}

	let { client, folderListStore = $bindable(), onSelectionChanged }: Props = $props();

	let folderListId = 'folder-list';
	let showCreateFolderModal = $state(false);

	async function handleCreateFolder() {
		showCreateFolderModal = true;
		//Scroll the view to top
		document.getElementById(folderListId)!.scrollTop = 0;
	}

	onMount(async () => {
		//Only use apply filter if the client we now get is diffrent from the data that we currently have in the list.
		if (folderListStore.data?.length <= 0 || folderListStore.data[0].fkClient != client.id) {
			//Load the data
			await folderListStore.applyFilter();
		} else {
			//Restore the selection and scroll
			let lastSelectedFolderIndex = folderListStore.applyMemoryToList();

			if (lastSelectedFolderIndex) {
				//Scroll to the position. We can't do it right now because it's possible that we are faster
				//than on mount. This will result in not finding the list
				document
					.getElementById(folderListId)
					?.children[lastSelectedFolderIndex]?.scrollIntoView(true);
			}
		}
	});

	onDestroy(() => {
		folderListStore.syncGlobalStore();
	});
</script>

<!--Edit modal-->
{#if $editFolderStore}
	<FolderEditModal patchFolderStore={folderListStore.patchFolderStore} />
{/if}

{#if showCreateFolderModal}
	<FolderCreateModal
		postFolderStore={folderListStore.createFolderStore}
		onModalClose={() => {
			showCreateFolderModal = false;
		}}
	/>
{/if}

<!--Folder List-->
<div class="h-full grid grid-rows-[auto_1fr]">
	<div class="flex items-center pb-9 pl-8 gap-8">
		<Searchbar
			onSearchTrigger={() => {
				folderListStore.applyFilter();
			}}
			placeholder={$_('folderview.lbl_search_folder')}
			bind:filter={folderListStore.listFilter}
		/>
		<IconButton
			iconName="folder-circle-plus"
			hoverText={$_('folderview.lbl_folder_default_name')}
			primary={true}
			onClick={handleCreateFolder}
		/>
	</div>

	<div class="relative">
		<div class="absolute top-0 left-0 bottom-0 right-0">
			<DefaultSimpleList
				bind:store={folderListStore}
				onSelectionChanged={(item) => {
					onSelectionChanged(item as Folder);
				}}
				onAddRequest={handleCreateFolder}
				id={folderListId}
				itemComponent={ListItemFolder}
			/>
		</div>
	</div>
</div>
